import { render, staticRenderFns } from "./MultiFieldWidget.vue?vue&type=template&id=0f9f53ab&scoped=true"
import script from "./MultiFieldWidget.vue?vue&type=script&lang=js"
export * from "./MultiFieldWidget.vue?vue&type=script&lang=js"
import style0 from "./MultiFieldWidget.vue?vue&type=style&index=0&id=0f9f53ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9f53ab",
  null
  
)

export default component.exports